import { css } from 'styled-components';
import dsTokens from '@frete.com/fuel-foundation/fretebras/theme.json';

const sizes = {
  mobile: '425px',
  tablet: '768px',
};

export const devices = {
  mobile: `(max-width: ${sizes.mobile})`,
  tablet: `(max-width: ${sizes.tablet})`,
};

export const mediasQuery = {
  maxMdMax: `@media screen and (max-width: ${dsTokens.breakpoint.md.maxWidth})`,
  maxMdMin: `@media screen and (max-width: ${dsTokens.breakpoint.md.minWidth})`,
  minMdMin: `@media screen and (min-width: ${dsTokens.breakpoint.md.minWidth})`,
};

export const stylesDivider = css`
  ${({ theme }) => css`
    border-top: ${theme.border.width.thinner} ${theme.border.style.solid}
      ${theme.color.border.neutral.default};
  `}
`;

export const stylesWrapperActionFixed = css`
  ${({ theme }) => css`
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    background-color: ${theme.color.background.neutral.default};
    padding: ${theme.spacing.km4} ${theme.spacing.km6};
    max-width: 780px;
    margin: 0 auto;
    right: 0;
    z-index: 10;
    ${stylesDivider}
  `}
`;

export function handleTruncatedTextInSmallScreens(
  text: string,
  maxWidth: number,
): string {
  const widthWindow = window.screen.availWidth;

  if (text.length > maxWidth && widthWindow >= 1024 && widthWindow <= 1366) {
    return `${text.slice(0, maxWidth)}...`;
  }

  return text;
}
